export default __webpack_public_path__ + "static/media/thue_xe_oto_tu_lai_va_co_tai.9df79c9f.png";